module.exports = __webpack_public_path__ + "static/img/klzyy.ed2babb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/klzyy.jpg
// module id = E7h5
// module chunks = 74